import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Renderable } from 'src/openapi-client/model/renderable';

@Component({
  selector: 'wct-simple-table',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './simple-table.component.html',
  styleUrls: ['./simple-table.component.scss'],
})
export class SimpleTableComponent {
  @Input({ required: true }) public data: Renderable;
}

